/** Portrait used to be a full-screen "turn the phone sideways" veil.
 *  Portrait is a playable layout now, so this renders nothing. */

export function RotateHint(): JSX.Element | null {
  return null;
}
